import img1 from '/static/img/experience/traffic/sightseeing/img1.png'
import img2 from '/static/img/experience/traffic/sightseeing/img2.png'
import img3 from '/static/img/experience/traffic/sightseeing/img3.png'
import img4 from '/static/img/experience/traffic/sightseeing/img4.png'
import img5 from '/static/img/experience/traffic/sightseeing/img5.png'
const sightseeingInfo = {
    title:'Helicopter sightseeing',
    desc:'Helicopter sightseeing tours are available to avoid crowds or for emergency travel.',
    img1:img1,
    img2:img2,
    img3:img3,
    img4:img4,
    img5:img5
}
export default {
    sightseeingInfo
};